import { StatusCell, type StatusVariant } from '../../../../components/status/status-cell';
import type { LiveSyncState, SyncStatus } from '../types';

// The copy answers "did my change stick" (Saved / Saving…), the way Docs and
// Word do, not "is the socket open" — the connection only matters to the
// user when it is down, and Offline covers that. The resting state is muted
// so colour is reserved for the two states that ask for attention.
const liveChip: Record<
  LiveSyncState,
  { variant: StatusVariant; label: (pollMs: number) => string }
> = {
  connecting: { variant: 'muted', label: () => 'Connecting…' },
  live: { variant: 'muted', label: () => 'Saved' },
  saving: { variant: 'attention', label: () => 'Saving…' },
  // Quotes the hook's own poll period, so the user is told exactly how
  // stale the page can be until the socket is back.
  offline: { variant: 'danger', label: (pollMs) => `Offline · checking every ${pollMs / 1000}s` },
};

// The header's "how current is this page" indicator.
export function SyncIndicator({ sync }: { sync: SyncStatus }) {
  const { variant, label } = liveChip[sync.state];

  return (
    <StatusCell variant={variant} tone="soft" className="justify-self-end font-mono">
      {label(sync.pollMs)}
    </StatusCell>
  );
}
